<script lang="ts" src="./component.ts"></script>
<style lang="scss" src="./component.scss"></style>

<template>
  <SharedWindow :class="b()" @close="handleClose">
    <div :class="b('wrapper')">
      <h3 :class="b('title')">Редактирование заявки</h3>

      <div :class="b('fields')">
        <div :class="b('field')">
          <h4 :class="b('field-title')">Статус</h4>

          <SharedSelect
            view="light"
            :options="displayedStatusOptions"
            v-model:value="adminApplicationShow.status"
          />
        </div>

        <div :class="b('field')">
          <h4 :class="b('field-title')">
            Этап (Добавляте этапы построчно используя Enter)
          </h4>

          <UITextArea
            view="light"
            rows="4"
            placeholder="Добавьте комментарий при необходимости"
            v-model="adminApplicationShow.stage"
          />
        </div>

        <div :class="b('field')">
          <h4 :class="b('field-title')">
            Cумма сделки {{ adminApplicationShow.currency_name_from }}
          </h4>

          <SharedInputCurrency
            placeholder="Введите новую сумму"
            :value="adminApplicationShow.amount"
            :disabled="true"
            :currency="adminApplicationShow.currency_from"
            @update:value="handleAmount"
          />
        </div>

        <div :class="b('field')">
          <h4 :class="b('field-title')">
            Изменить комиссию {{ adminApplicationShow.currency_name_from }}
          </h4>

          <SharedInputCurrency
            placeholder="Введите новую сумму"
            :value="adminApplicationShow.commissions"
            :currency="currencyForExecutionPrice"
            @update:value="handleCommission"
          />
        </div>
      
        <div :class="b('field')">
          <h4 :class="b('field-title')">
            Изменить цену исполнения
            {{ adminApplicationShow.currency_name_to }} к
            {{ adminApplicationShow.currency_name_from }}
          </h4>

          <SharedInputCurrency
            placeholder="Введите новую сумму"
            :value="adminApplicationShow.execution_price"
            :currency="currencyForExecutionPrice"
            @update:value="handleExecutionPrice"
          />
          <div
            v-if="
              adminApplicationShow.execution_price &&
              adminApplicationShow.execution_price > 0
            "
            :class="b('inverse-rate')"
          >
            курс {{ adminApplicationShow.currency_name_from }}/{{
              adminApplicationShow.currency_name_to
            }}
            = {{ (1 / adminApplicationShow.execution_price).toFixed(8) }}
          </div>
        </div>

        <div :class="b('field')">
          <h4 :class="b('field-title')">
            Объем сделки {{ adminApplicationShow.currency_name_to }}
          </h4>

          <SharedInputCurrency
            placeholder="Введите новую сумму"
            :value="adminApplicationShow.transaction_volume"
            :currency="adminApplicationShow.currency_to"
            :disabled="true"
            @update:value="handleTransactionVolume"
          />
        </div>
      </div>

      <UIButton
        label="Сохранить"
        view="main"
        :disabled="isDisabled"
        @click="handleSave"
      />
    </div>
  </SharedWindow>
</template>
